<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row">
        <div v-show="showData" class="col-lg-12">

          <AppForm
            ref="pageForm"
            v-bind:formParameter="PARAM" />

        </div>
      </div>

      <br>

      <button v-show="allowSave && showData" v-on:click="onSaveButtonClick" type="button" class="btn btn-primary">
        Save
      </button>

      <br>
      <br>

      <TemplateFeedback ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import AppForm from "@/components/App/AppForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const INPUT_TYPE_NUMBER = {
  type: 'number',
};
const PARAM = [
  {
    form_section: 'PL System Activity Dates',
  },
  {
    key: 'licenseGraceDays',
    text: 'Grace Period to Void Unpaid PL *',
    form_muted : 'Number of days before the PL commencement date',
    form_input_attr: INPUT_TYPE_NUMBER,
  },
  {
    key: 'licenseLateReminder1Date',
    text: 'Site Wide PL 1st Late Payment Reminder Date *',
    form_muted : 'Day of the month to send 1st Late Payment Reminder Email',
    form_input_attr: INPUT_TYPE_NUMBER,
  },
  {
    key: 'licenseLateReminder2Date',
    text: 'Site Wide PL 2nd Late Payment Reminder Date *',
    form_muted : 'Day of the month to send 2nd Late Payment Reminder Email',
    form_input_attr: INPUT_TYPE_NUMBER,
  },
  {
    key: 'licenseLatePaymentDate',
    text: 'Site Wide PL Late Payment Date *',
    form_muted : 'Day of the month to perform Late Payment and Block Card',
    form_input_attr: INPUT_TYPE_NUMBER,
  },
  {
    key: 'licenseStopBillDate',
    text: 'Site Wide PL Stop Bill Date *',
    form_muted : 'Day of the month to perform Stop Bill',
    form_input_attr: INPUT_TYPE_NUMBER,
  },
  {
    key: 'licenseBillingDate',
    text: 'Site Wide PL Billing Date',
    form_muted : 'Day of the month to generate inovices to customers',
    form_input_attr: INPUT_TYPE_NUMBER,
  },
  {
    key: 'licenseExemptedDays',
    text: 'Site Wide PL Days Exempted from Void *',
    form_muted : 'Number of days to void the PL exempted from Void after the PL commencement date.',
    form_input_attr: INPUT_TYPE_NUMBER,
  },
];

export default {
  name: "PageSystemActivityDate",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    AppForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Administration' },
        { name: 'Parking License Management' },
        { name: 'System Activity Dates' },
      ],

      PARAM,

      showData: false,
      allowSave: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    if(helper.hasEditPermission(this.permission)) {
      this.allowSave = true;
    }
    
    // this.loadCity();
    this.loadData();
  },
  methods: {
    loadData() {
      let feedbackItem = 'system activity dates'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/configure',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.$refs['pageForm'].setForm(false, response.data[0]);
          this.showData = true;
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },

    onSaveButtonClick() {
      let feedbackItem = 'system activity dates'
      this.$refs['pageFeedback'].setFeedbackLoading('Saving ' + feedbackItem);
      this.$http
        .post(
          helper.SERVER_URL + '/api2/configure',
          querystring.stringify(this.$refs['pageForm'].formData),
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully save ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'saving', feedbackItem));
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Admin/PageSystemActivityDate.vue